import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  conversionDateTimeUtc: '',
  conversionRate: 1,
  fromCurrency: 'USD',
  toCurrency: 'USD'
};

let defaultFilters = {
  fromCurrency: '',
  toCurrency: '',
  startDate: '',
  endDate: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};